import Tenants from "./Tenants";

export {Tenants};